var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonWithIcon',{attrs:{"icon":"mdi-plus","label":_vm.label,"disabled":_vm.disabled},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }